module.exports = __webpack_public_path__ + "img/1.60c97658.png";